import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { data } from '../../../../data/graph_data';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

export const options = {
  responsive: true,
  maintainAspectRatio: false, // important to allow 100% width & height
  plugins: {
    legend: {
      position: 'top',
      labels: {
        color: '#ffffff', // Legend text color white
      },
    },
    title: {
      display: true,
      text: 'Monthly Sale Graph',
      color: '#ffffff', // Title color white
    },
    tooltip: {
      titleColor: '#ffffff',
      bodyColor: '#ffffff',
      backgroundColor: 'rgba(0,0,0,0.7)',
    },
  },
  scales: {
    x: {
      ticks: {
        color: '#ffffff', // X-axis labels white
      },
      grid: {
        color: 'rgba(255,255,255,0.2)', // X-axis grid lines faint white
      },
    },
    y: {
      ticks: {
        color: '#ffffff', // Y-axis labels white
      },
      grid: {
        color: 'rgba(255,255,255,0.2)', // Y-axis grid lines faint white
      },
    },
  },
};

export const WaveChart = () => {
  const updatedData = {
    ...data,
    datasets: data.datasets.map((dataset) => ({
      ...dataset,
      borderColor: '#ffffff', // line color white
      backgroundColor: 'rgba(255, 255, 255, 0.2)', // fill under line
      pointBackgroundColor: '#ffffff', // points white
      pointBorderColor: '#ffffff',
    })),
  };

  return (
    <div className="w-[50%] h-[350px] p-4 bg-gray-700 rounded-lg">
      {/* Chart will fill 100% width & height of parent */}
      <Line options={options} data={updatedData} style={{ width: '100%', height: '100%' }} />
    </div>
  );
};
